
import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import getCorso from "../../services/getCorso";
import updateCorso from "../../services/updateCorso";
import getStudenti from "../../services/getStudenti";
import { NineCellLoading } from 'react-loadingg';
import moment from 'moment';
import Table from '../../widgets/tables/Table';
import getEsami from "../../services/getEsami";
import getValutazioniCorso from "../../services/getValutazioniCorso";
import checkUtente from "../../services/checkUtente";
import getMaterie from '../../services/getMaterie';
import AdWidget from "../../widgets/AdWidget";
import translateString from "../../utils/Locales";
import Utils from "../../utils/utils";
import getAllDocuments from "../../services/getAllDocuments";
import getTests from "../../services/getTests";

let t = translateString;

export default class EditCorsoStudent extends React.Component {

	constructor(props){
		super (props)
	
		this.pageDiv = {
			border: '1px solid #cccccc',
			padding: 10
		};
	
		this.section = this.props.section
		if (this.section == undefined){
			const pathname = props.location.pathname;
			this.section = pathname.substring(8, pathname.length);
		}

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined){
			this.pageName = this.section;
		}

		this.userslist = [];
		this.studenti = [];
		this.tests = [];

		this.grid = 2;
		this.startDateRef = React.createRef();
		this.endDateRef = React.createRef();
		const cookies = new Cookies();
		this.dbPath = cookies.get('db_path', { path: '/' });

		this.state = {
			details: [],
			insertEsameShow: false, 
			exams: [], 
			retiredDetails: '', 
			isLoading: true
		};

	}

	async loadEsami(){

		const cookies = new Cookies();
		const username = cookies.get('username', { path: '/' });
		const token = cookies.get('token', { path: '/' });
		this.esami = await getEsami(username, token, this.corso.id);
		const currentCourse = cookies.get('currentCourse', { path: '/' });
		this.documents = await getAllDocuments(username, token, currentCourse);
		this.documents.forEach((doc, i) => {
			if (doc.tipo === '0') {
				this.documents[i].id_mittente = 'Admin'
			}
		})
	}

	async loadComponent() {
		const cookies = new Cookies();
		const username = cookies.get('username', { path: '/' });
		const token = cookies.get('token', { path: '/' });
		const currentCourse = cookies.get('currentCourse', { path: '/' });
		if (!currentCourse) {
			window.location.href = '/' + this.dbPath + '/#/app/dashboard'
			return
		}

		Utils.setAnalyticsPage('Course details (STUDENT USER + ' + username + '): ' + cookies.get('currentCourse', { path: '/' }) + ' - ' + cookies.get('db', { path: '/' }));

		this.utente = await checkUtente(username, token, username);
		this.corso = await getCorso(username, token, currentCourse);
		this.studenti = await getStudenti(username, token);
		this.materie = await getMaterie(username, token);
		this.tests = await getTests(username, token, currentCourse);
		this.currUtente = this.studenti.filter((studente) => studente.id === this.utente[0].user_id)[0];
		this.valutazioni = await getValutazioniCorso(username, token, this.corso.id);
		this.valutazioni = this.valutazioni.filter((voto) => voto.id_studente === this.currUtente.id);
		await this.loadEsami();

		this.esami.forEach((esame) => {
				this.valutazioni.forEach((v) => {
					if (v.id_esame === esame.id) {
						esame.valutazione = v.valutazione;
					}
				});

				esame.tipo = esame.type === '1' ? t('scritto') : t('orale');
				this.materie.forEach((materia) => {
					if(materia.id === esame.id_materia) {
						esame.materia = materia.materia;
					}
				});
				if (esame.materia === undefined) {
					esame.materia = '';
				}
		});
		this.esami = this.esami.filter((esame) => esame.valutazione !== undefined && esame.valutazione !== '-1');

		this.setState({corso: this.corso, isLoading: false });
	}

	async componentDidMount(){
		await this.loadComponent();
	}

	render () {
	
			var headCellsEsami = [
				{ id: 'data', numeric: true, disablePadding: false, label: t('data') },
				{ id: 'materia', numeric: true, disablePadding: false, label: t('materia') },
				{ id: 'nome_insegnante', numeric: true, disablePadding: false, label: t('insegnante') },
				{ id: 'nome', numeric: false, disablePadding: true, label: t('note') },
				{ id: 'tipo', numeric: false, disablePadding: true, label: t('tipologia') },
				{ id: 'valutazione', numeric: false, disablePadding: true, label: t('valutazione') },
			];
			var headCellsDocumenti = [
				{ id: 'filename', numeric: false, disablePadding: false, label: t('file') },
				{ id: 'id_mittente', numeric: false, disablePadding: true, label: t('mittente') },
				{ id: '_', numeric: true, disablePadding: false, label: '' }
			];
			var headCellsTests = [
			{ id: 'nome_esame', numeric: false, disablePadding: false, label: t('nome') },
			{ id: 'materia', numeric: false, disablePadding: false, label: t('materia') },
		];

			this.searchColsEsami = ['nome'];
			this.searchColsDocumenti = ['filename', 'id_mittente'];
			this.searchColsTests = ['nome_esame'];

		if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

		if (this.state.corso == undefined) return <div />;

		return (
			<>
			<LoadingOverlay
			active={this.state.isLoading}
			styles={{
				content: (base) => ({
					position: 'relative',
					width: '100%',
					top: '200px'
				})
			}}
			spinner
			text={'Loading your content...'}
			>
				<PageTitle title={t('tue_valutazioni')} />
				<Table headCells={headCellsEsami} searchCols={this.searchColsEsami} calendar={false} excel={false} pdf={false} rows={this.esami} /> 
				<AdWidget bottomWidget={true} />

				{/*             DOCUMENTI             */}

			<PageTitle title={t('documenti')} onClick={() => {
				this.setState({uploadDocumentShow: true})
				}}
			/>
			<Table headCells={headCellsDocumenti} searchCols={this.searchColsDocumenti} download={true} rows={this.documents}/>
			

			

			{/*             ESAMI             */}

			<PageTitle title={t('test_online')}/>
			<Table headCells={headCellsTests} searchCols={this.searchColsTests} rows={this.tests} 
				onEventClick={(id) => {
					let test = this.tests.filter((t) => {
						return t.id === id
					})[0];
					if (!test.durata) {
						window.location.href =  '/' + this.dbPath + '/#/app/infoTest?id=' + id
					}
				}}

				onTestDone={(id) => {
					
				}}
				
			/>

				</LoadingOverlay>
			</>
		);
	}

	async save (){
			const cookies = new Cookies();
			const username = cookies.get('username', { path: '/' });
			const token = cookies.get('token', { path: '/' });

			const xStartDate = this.startDateRef.current.getDate();
			const xEndDate = this.endDateRef.current.getDate();

			let startDate = moment(xStartDate).format('yyyy-MM-DD');
			let endDate = moment(xEndDate).format('yyyy-MM-DD');

			if (xEndDate < xStartDate){
				Utils.showInfo(t('controlla_date'));
				return;
			}
	
			await updateCorso(username, token, this.state.corso.id, this.state.corso.name, startDate, endDate, this.state.corso.divisione_fatturato, this.state.corso.visibleStudent, this.state.corso.visibleTeacher, this.state.corso.anno_accademico);
			window.location.href =  '/' + this.dbPath + '/#/app/corsi';
	}

}

